<template>
  <div v-if="list.length">
    <van-swipe class="swiper" :autoplay="3000" :show-indicators="false">
      <van-swipe-item v-for="(item, index) in list" :key="index" class="swiper-item">
        <iain-image-domain :radius="0" :src="item.image" />
        <div class="swiper-title">{{ item.title }}</div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.swiper {
  border-radius: 12px;
  height: 240px;

  .swiper-item {
    position: relative;
    width: 100vw;

    .swiper-title {
      box-sizing: border-box;
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      display: flex;
      align-items: center;
      padding: 0 30px;
      width: 100%;
      height: 46px;
      font-size: 24px;
      color: #ffffff;
      background: rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
